import React from 'react'

import { useIntl } from 'gatsby-plugin-react-intl'

import * as S from './styled'
import { Heading } from '../Heading'

export function SimpleCard({ title, text, textColor, typeCard, italic, maxWidth, titleCheck }) {
  const intl = useIntl()
  const link = intl.formatMessage({ id: 'simple_card_deck_services.link' })

  return (
    <>
      {(() => {
        switch (typeCard) {
          case 'takedown':
            return (
              <S.SimpleCardWrapper>
                <Heading size="small" as="h3">
                  Takedown
                </Heading>
                <p>{intl.formatMessage({ id: 'simple_card_deck_services.takedown.text' })}</p>
                <S.SmallLink to="/solucoes/takedown/">{link}</S.SmallLink>
              </S.SimpleCardWrapper>
            )

          case 'managed-services':
            return (
              <S.SimpleCardWrapper>
                <Heading size="small" as="h3">
                  {intl.formatMessage({ id: 'simple_card_deck_services.managed_services.title' })}
                </Heading>
                <p>{intl.formatMessage({ id: 'simple_card_deck_services.managed_services.text' })}</p>
                <S.SmallLink to="/solucoes/servicos-gerenciados/">{link}</S.SmallLink>
              </S.SimpleCardWrapper>
            )

          case 'axur-research-team':
            return (
              <S.SimpleCardWrapper>
                <Heading size="small" as="h3">
                  Axur Research Team
                </Heading>
                <p>{intl.formatMessage({ id: 'simple_card_deck_services.axur_research_team.text' })}</p>
                <S.SmallLink to="/solucoes/axur-research-team/">{link}</S.SmallLink>
              </S.SimpleCardWrapper>
            )

          default:
            return (
              <S.SimpleCardWrapper titleCheck={titleCheck} style={{ maxWidth, color: textColor }}>
                <Heading size="small" as="h3">
                  {title}
                </Heading>
                <p>
                  {text}
                  <span>{italic}</span>
                </p>
              </S.SimpleCardWrapper>
            )
        }
      })()}
    </>
  )
}
